import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useFormikContext } from 'formik'
import { VinciInput } from '~/components'
import { ICompany, companyTypeOptions } from '~/utils/types'

import { useTranslation } from 'react-i18next'
import { useAuth } from '~/hooks/useAuth'
import * as S from './CompanyForm.styles'

type CompanyFormValues = ICompany

export const CompanyForm = () => {
  const formik = useFormikContext<CompanyFormValues>()

  const { isAssigned } = useAuth()

  const { t } = useTranslation()

  return (
    <S.Wrapper>
      <S.InputGroupWrapper>
        <VinciInput
          name='name'
          label={`${t('Name')} *`}
          value={formik.values.name}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.name)}
          helperText={formik.errors.name}
          fullWidth
        />
        {/* </S.InputGroupWrapper>
      <S.InputGroupWrapper> */}
        {/* <VinciInput
          name='initials'
          label={`${t('Initials')} *`}
          value={formik.values.initials}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.initials)}
          helperText={formik.errors.initials}
          fullWidth
        /> */}
        <FormControl fullWidth>
          <InputLabel id='company-type-label'>{t('Company Type')}</InputLabel>
          <Select
            labelId='company-type-label'
            name='company_type'
            placeholder={`${t('Company Type')} *`}
            label={`${t('Company Type')} *`}
            value={formik.values.company_type}
            onChange={formik.handleChange}
            multiple
          >
            {companyTypeOptions
              .filter((companyType) =>
                companyType.requiredPermission ? isAssigned(companyType.requiredPermission) : true,
              )
              .map((companyType) => (
                <MenuItem key={companyType.name} value={companyType.name}>
                  {companyType.label}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </S.InputGroupWrapper>
      <S.InputGroupWrapper>
        {/* <Box>
          <Typography
            variant='h6'
            color='secondary.light'
            sx={{ marginTop: 5, width: '33%', flexShrink: 0 }}
          >
            {t('Aliases')}
            {formik.errors.aliases && (
              <Typography color='error.main'>{t('Company must be at least 1 alias')}</Typography>
            )}
          </Typography>
          <S.AliasesWrapper>
            {formik?.values?.aliases?.map((alias, index) => (
              <VinciControlledChip
                key={alias}
                label={alias}
                onChange={(newAlias) => {
                  const newAliases = [...formik.values.aliases]
                  newAliases[index] = newAlias
                  formik.setFieldValue('aliases', newAliases)
                }}
                canDelete
                onDelete={() => {
                  const newAliases = [...formik.values.aliases]
                  newAliases.splice(index, 1)
                  formik.setFieldValue('aliases', newAliases)
                }}
              />
            ))}
            {isCreatingAlias && (
              <VinciControlledChip
                label=''
                onChange={(newAlias) => {
                  const newAliases = isArray(formik.values.aliases)
                    ? [...formik.values.aliases]
                    : [formik.values.aliases]
                  newAliases.push(newAlias)
                  formik.setFieldValue('aliases', newAliases)

                  setIsCreatingAlias(false)
                }}
                hoverText='Type a new alias'
                autoFocus
                canDelete
                onDelete={() => {
                  setIsCreatingAlias(false)
                }}
              />
            )}
            <Chip
              onClick={() => {
                setIsCreatingAlias(true)
              }}
              sx={{ margin: 1, cursor: 'pointer' }}
              label={t('New')}
              color='primary'
            />
          </S.AliasesWrapper>
        </Box> */}
      </S.InputGroupWrapper>
    </S.Wrapper>
  )
}
